import { render, staticRenderFns } from "./RiskRecGraph.vue?vue&type=template&id=61b66614&scoped=true&"
import script from "./RiskRecGraph.vue?vue&type=script&lang=js&"
export * from "./RiskRecGraph.vue?vue&type=script&lang=js&"
import style0 from "./RiskRecGraph.vue?vue&type=style&index=0&id=61b66614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b66614",
  null
  
)

export default component.exports